export const DILUTION_PDF_CONFIG = {
  COLUMNS_WIDTH: 544,
  COLUMN_WIDTH: 68,
  MAX_CHARS_LIMIT_FOR_VALUES: 12,
};
